import axios, { AxiosInstance } from 'axios';
import { resolveApiTimeout, resolveApiUrl } from './apiConfig';
import { beginProcessing, describeApiOperation, endProcessing } from '../utils/processing';

const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
const API_URL = resolveApiUrl({
  environment: process.env.NODE_ENV || 'development',
  envUrl: process.env.REACT_APP_API_URL,
  envHost: process.env.REACT_APP_API_HOST,
  envPort: process.env.REACT_APP_API_PORT,
  envPath: process.env.REACT_APP_API_PATH,
  browserHostname: window.location.hostname || 'localhost',
});
const API_TIMEOUT = resolveApiTimeout(process.env.REACT_APP_API_TIMEOUT_MS);

if (IS_DEVELOPMENT) {
  console.info('[SysMadd] API:', API_URL);
}

const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: API_TIMEOUT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    beginProcessing(describeApiOperation(config.method, config.url));
    (config as any).__sysmaddProcessing = true;
    return config;
  },
  (error) => {
    endProcessing();
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if ((response.config as any).__sysmaddProcessing) endProcessing();
    return response;
  },
  (error) => {
    if ((error.config as any)?.__sysmaddProcessing) endProcessing();

    if (IS_DEVELOPMENT) {
      console.error('[SysMadd] Falha na API:', {
        status: error.response?.status,
        url: error.config?.url,
        message: error.response?.data?.message || error.message,
        requestId: error.response?.data?.requestId,
      });
    }

    const requestUrl = String(error.config?.url || '');
    const isAuthRequest = requestUrl.includes('/auth/login')
      || requestUrl.includes('/auth/me')
      || requestUrl.includes('/auth/logout');

    if (error.response?.status === 401 && !isAuthRequest && window.location.pathname !== '/login') {
      window.location.assign('/login');
    }

    return Promise.reject(error);
  }
);

export default api;
